import React from 'react';
import '../styles/nav.css';

export default function Navbar() {
  return (
    <nav>
      <h1>Knockdown Bridge</h1>
      <a href="https://timrobillard.ca/">By Tim Robillard</a>
    </nav>
  )
}
